const config = {
  requestConfig:
    '?api_key=1737d8c5ebe38928824e808534d92059&language=pt-BR&region=BR',
  dbUrl: 'https://api.themoviedb.org/3/',
  dbUrlCEP: 'https://viacep.com.br/ws/',
};

export default config;
